import { findSearchMatchRange } from "@/utils/search-text";

function renderHighlight(
  text: string,
  range: { start: number; end: number },
  isTooltip?: boolean
): JSX.Element {
  return (
    <span>
      {text.slice(0, range.start)}
      <span
        style={{
          backgroundColor: "#E2F8FF",
          color: isTooltip ? "#856404" : undefined,
        }}
      >
        {text.slice(range.start, range.end)}
      </span>
      {text.slice(range.end)}
    </span>
  );
}

export function highlightPartialText(
  text: string | undefined,
  keywords: (string | undefined)[],
  isTooltip?: boolean
): JSX.Element | string | undefined {
  if (!text || keywords.length === 0) return text;

  const range = findSearchMatchRange(text, keywords);
  if (!range) return text;

  return renderHighlight(text, range, isTooltip);
}

export function escapeRegExp(str: string) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

/**
 * highlightPartialText와 동일하다. 과거 두 구현이 나뉘어 있던 시절의 호출부를
 * 깨지 않기 위해 이름만 남겨둔다.
 */
export function highlightPartialTextThorough(
  text: string | undefined,
  keywords: (string | undefined)[],
  isTooltip?: boolean
): JSX.Element | string | undefined {
  return highlightPartialText(text, keywords, isTooltip);
}
